// namespace
window.Components = window.Components || {};

(function($) {

  'use strict';

  function ajaxForm() {

    var self = this,
        url = false,
        isProcessing = false,
        $cache = {};

    /**
     * Clear inputs
     */
    function clear() {
      $cache.formFields.each(function(){
        var $el = $(this);
        $el.val('');
      });
    }

    /**
     * Display message
     */
    function displayMessage(valid, message) {
      message = message || false;
      if(valid) {
        //Valid Message
        $cache.messageValid.html($cache.messageValid.data('message'));
        if(message) $cache.messageValid.html(message);

        $cache.formMessage.addClass('valid');

        setTimeout(function(){
            var redirect_link = $cache.form.data('redirect');
            window.location.href = redirect_link;
        }, 250);

      } else {
        //Error Message
        $cache.messageError.html($cache.messageError.data('message'));
        if(message) $cache.messageError.html(message);

        $cache.formMessage.addClass('error');
      }
    }

    /**
     * Hide message
     */
    function hideMessage() {
      $cache.formMessage.removeClass('error valid');
    }

    function initRecaptcha() {
        refreshRecaptcha();
        console.log('initRecaptcha');

        setInterval(function() {
          refreshRecaptcha();
        }, 120000);
    }

    function refreshRecaptcha() {
        /* eslint-disable no-undef */
        grecaptcha.ready(function () {
            grecaptcha.execute(recaptchaSiteKey, { action: 'contact' }).then(function(token) {
                $cache.main.find('input[name="recaptcha_response"]').val(token);
            });
        });
        /* eslint-enable no-undef */
    }

    /**
     * Submit form
     */
    function submitForm() {      
      if(isProcessing) return;
      isProcessing = true;

      //Clear old message
      hideMessage();

      // Update form fields
      $cache.formFields = $cache.form.find('input:not([type="submit"]), textarea');

      //Clear old submitted values
      self.formData = new FormData();

      $cache.formFields.each(function(){
        var $el = $(this);

        // console.log( $el.attr('name') );

        if( $el.attr('name') === 'file'){
          var $file = document.getElementById('file').files;
          self.formData.append('file', $file[0]);
          // self.formData.append($el.attr('files')[0], $el.val());
        } else if ($el.attr('name') !== 'file[]') {
          self.formData.append($el.attr('name'), $el.val());
        }
      });

      var files = $cache.form.find('input[name="file[]"]');
      if (files.length > 0) {
          for (var index = 0; index < files.length; index++) {
              self.formData.append("file[]", files[index].files[0]);
          }
      }

      $.ajax({
          method: 'POST',
          url: url, // check the exact URL for your situation
          dataType: 'JSON',
          cache: false,
          contentType: false,
          processData: false,
          data: self.formData,
          success: function(data) {
              // Display message
              displayMessage(data.success, data.message);

              // Reset recaptcha
              // grecaptcha.reset();
              refreshRecaptcha();

              // Release Submit
              isProcessing = false;
          },
          error: function(errorThrown) {
              console.log("Error");
              console.log(errorThrown);

              // Display message
              displayMessage(false, null);

              // Reset recaptcha
              refreshRecaptcha();
              // grecaptcha.reset();

              // Release Submit
              isProcessing = false;

              return false;
          }
      });       
    }
    
    /**
     * Init Cache
     */
    function initCache(target) {
      $cache.main = target;
      $cache.form = $cache.main.find('form');
      $cache.formFields = $cache.form.find('input:not([type="submit"]), textarea');
      $cache.formMessage = $cache.form.find('.form-message');
      $cache.messageValid = $cache.formMessage.find('.valid');
      $cache.messageError = $cache.formMessage.find('.error');

      
    }

    /**
     * Register Events
     */
    function registerEvents() {
    }


    /**
     * Public constructor
     * @param  {Object} opts Options
     */
    self.initialize = function(target) {      
      initCache(target);

      url = $cache.main.data('url');

      registerEvents();

      initRecaptcha();
      
      //Initial call
      $cache.form.validate({ rules: {
                                file: {
                                  required: true,
                                  extension: "pdf|doc|docx|jpg|jpeg|png"
                                }
                              },
                              submitHandler: submitForm });
    };

    self.initialize.apply(self, arguments);
    return self;
  }
  
  window.Components.ajaxForm = ajaxForm;
  
}(jQuery));
